/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./nav-left.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./nav-left.component";
var styles_NavLeftComponent = [i0.styles];
var RenderType_NavLeftComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_NavLeftComponent, data: {} });
export { RenderType_NavLeftComponent as RenderType_NavLeftComponent };
export function View_NavLeftComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "ul", [["class", "navbar-nav mr-auto"]], null, null, null, null, null)), (_l()(), i1.ɵeld(1, 0, null, null, 0, "li", [["class", "nav-item"]], null, null, null, null, null))], null, null); }
export function View_NavLeftComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-nav-left", [], null, null, null, View_NavLeftComponent_0, RenderType_NavLeftComponent)), i1.ɵdid(1, 114688, null, 0, i2.NavLeftComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var NavLeftComponentNgFactory = i1.ɵccf("app-nav-left", i2.NavLeftComponent, View_NavLeftComponent_Host_0, {}, {}, []);
export { NavLeftComponentNgFactory as NavLeftComponentNgFactory };
